import React, { createContext, useContext, useReducer } from "react";
import MemesReducer from "./MemesReducer";
import { useNavigate } from "react-router-dom";
import {
  getMemesRequest,
  getPhotosRequest,
  getPhotoRequest,
  getMemeRequest,
  postMemeRequest  } from "../../../shared/api/memes"

export interface IMemesContextType {
  memes: Array<any>;
  getMemes: (page: number) => void;
  meme: any,
  getMeme: (meme_identifier: string) => void;
  createMeme: (body: any) => void;
  photos: Array<any>;
  getPhotos: (page: number) => void;
  photo: any,
  getPhoto: (kitten_identifier: string, photo_id: string) => void;
  clearMeme: () => void;
}

const initialState: IMemesContextType = {
  memes: [],
  photos: [],
  photo: {},
  meme: {},
  getMemes: () => {},
  getMeme: () => {},
  getPhotos: () => {},
  getPhoto: () => {},
  createMeme: () => {},
  clearMeme: () => {}
}

const MemesContext = createContext(initialState);

export const useMemes = () => useContext(MemesContext);

const MemesProvider = (props: any) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(MemesReducer, initialState);

  // gets a list of memes
  const getMemes = (page: number) => {
    getMemesRequest(page).then(response =>
      dispatch({type: 'GET_MEMES', payload: response})
    );
  };

  // gets a list of memes
  const getMeme = (meme_identifier: string) => {
    getMemeRequest(meme_identifier).then(response =>
      dispatch({type: 'GET_MEME', payload: response})
    );
  };

  // creates a meme
  const createMeme = (body: any) => {
    postMemeRequest(body).then(response =>
      navigate(`/${response.identifier}`)
    );
  };

  // gets all photos that can be used for creating memes
  const getPhotos = (page: number) => {
    console.log(page, 'req page');
    getPhotosRequest(page).then(response =>
      dispatch({type: 'GET_PHOTOS', payload: response})
    );
  };

  // gets a single photo to be used for creating a new meme
  const getPhoto = (kitten_identifier: string, photo_id: string) => {
    getPhotoRequest(kitten_identifier, photo_id).then(response =>
      dispatch({type: 'GET_PHOTO', payload: response})
    );
  };

  // clears the meme state
  const clearMeme = () => {
    dispatch({type: 'CLEAR_MEME', payload: null})
  };

  return(
    <MemesContext.Provider value={{
      memes: state.memes,
      getMemes: getMemes,
      meme: state.meme,
      getMeme: getMeme,
      photos: state.photos,
      getPhotos: getPhotos,
      photo: state.photo,
      getPhoto: getPhoto,
      createMeme: createMeme,
      clearMeme: clearMeme
    }}>
      {props.children}
    </MemesContext.Provider>
  )
}

export default MemesProvider;